<template>
  <div id="order-comfirm-pay-info">

    <div class="pay-info-box">

      <!-- 可用余额 -->
      <div class="avaliable-balance">
        <div class="recharge-info" v-if="!User.is_palmyou && showRechargeCoupon"  @click="showRechargeDialog">
          <div class="recharge-info-label">优惠券不够用，充值送券</div>
          <img class="recharge-icon" src="https://o.666visa.cn/static/ssqpeer/order/recharge-coupon.png" alt="">
        </div>
        <!-- 余额信息 -->
        <div class="balance-box" v-if="!User.is_palmyou">
          <div class="balance-icon"></div>
          <div class="balance-label">可用余额</div>
          <div class="balance-value">¥ {{peer.balance_amount | price}}</div>
          <div class="recharge-btn" @click="showRechargeDialog">充值</div>
        </div>
      </div>

      <!-- 订单费用明细 -->
      <div class="order-pay-infos">

        <!-- 特价商品时限说明 -->
        <div class="special-price-date-explain" v-if="order.special_price">
          该特价商品将在<span>{{specialEndDate}}</span>后恢复原价
        </div>

        <ul class="order-pay-items">

          <!-- 商品金额 -->
          <li class="price">
            <div class="item-label">商品金额</div>
            <div class="item-value">
              <!-- 商品原价(仅特价商品显示) -->
              <span class="original-price" v-if="order.special_price">￥{{ productService.getPrice(order.peer_price * order.applicant.length) }}</span>
              <span v-if="!order.special_price && order.applicant">￥{{ productService.getPrice(order.applicant[0].sell_price * order.applicant.length) }}</span>
              <span v-if="order.special_price">￥{{ productService.getPrice(order.special_price * order.applicant.length) }}</span>
            </div>
          </li>

          <!-- 优惠券 -->
          <li class="coupon" v-if="orderSelectedCoupon && orderSelectedCoupon.id && !order.special_price">
            <div class="item-label">优惠券</div>
            <div class="item-value is-red">-￥{{ productService.getPrice(couponReducePrice) }}</div>
          </li>

          <!-- 顺丰上门取资料服务 -->
          <li v-if="sfChecked && pickupAmount">
            <div class="item-label">顺丰上门取资料服务</div>
            <div class="item-value">￥{{ pickupAmount / 100 }}</div>
          </li>

          <!-- 顺丰回寄运费 -->
          <li v-if="sfReturnExpressPrice">
            <div class="item-label">顺丰回寄运费</div>
            <div class="item-value">￥{{ sfReturnExpressPrice / 100 }}</div>
          </li>

          <!-- 旅游保险 -->
          <li v-if="order.product_insurance">

            <template v-if="order.product_insurance_new && (userInsurance.insurance_type === 1 && userInsurance.checked)">
              <div class="item-label">
                旅游保险
                <span>（¥{{(userInsurance.insurance_fee * userInsurance.insurance_discount) / order.applicant.length / 100}}×{{order.applicant.length}}）</span>
              </div>
              <div class="item-value">¥{{userInsurance.insurance_fee * userInsurance.insurance_discount / 100}}</div>
            </template>
            <!-- TODO 这里原来的判断是 order_insurance-->
            <template v-if="platInsurance.insurance_type === 2">
              <div class="item-label">
                旅游保险
                <span>{{`￥${insurancePriceText} x ${order.applicant.length}`}}</span>
              </div>
              <div class="item-value">￥{{(insurancePriceText) * order.applicant.length }}</div>
            </template>
            <template v-if="order.product_insurance.insurance_type === 3">
              <div class="item-label">
                旅游保险
                <span>{{`(￥0 * ${order.applicant.length})`}}</span>
              </div>
              <div class="item-value">￥0</div>
            </template>
          </li>

          <!-- 拒签无忧 -->
          <li v-if="showRejectProductModule" class="reject-product">
            <div class="item-label">拒签服务</div>
            <div class="item-value">￥{{ rejectProductPrice / 100 }}</div>
          </li>
        </ul>

        <!-- 应付金额 -->
        <div class="total-pay">
          <label>应付金额</label>
          <span><i>￥</i>{{ productService.getPrice(getPayAmount()) }}</span>
        </div>

        <!-- 立即支付按钮 -->
        <el-button type="primary" :disabled="loading" class="pay-button" @click="commit">立即支付</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/libs/user';
import Http from '@/libs/http';
import sensorsdata from 'sa-sdk-javascript';
import productService from '@/services/product-service';


export default {
  name: 'order-comfirm-pay-info',
  data() {
    return {
      productService,
      insurancePrice: undefined,
      User,
      showRechargeCoupon: false, // 是否显示充值送券
    };
  },
  props: {
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    peer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    pickupAmount: {
      type: Number,
      required: true,
      default: 0,
    },
    sfChecked: {
      type: Boolean,
      required: true,
      default: false,
    },
    sfReturnExpressPrice: {
      type: Number,
      required: true,
      default: 0,
    },
    rejectProductPrice: {
      type: Number,
      required: false,
      default: 0,
    },
    showRejectProductModule: {
      type: Boolean,
      default: false,
    },
    platInsurance: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    userInsurance: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    orderSelectedCoupon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {

    // 首本优惠删除
    /* firstFreeFee() {
      if (typeof this.order.pay_amount === 'undefined') return 0;

      // 如果当前需要支付的前大于最小支付额, 那就取首本价格, 否则就取总价减去需要支付的钱
      return this.getPayAmount() > this.order.min_pay_amount ? (this.order.first_order_reduce) : (this.totalAmount - this.getPayAmount());
    }, */

    // 特价截止日期
    specialEndDate() {
      const dateArray = this.order.special_end_date.split('-');
      return `${dateArray[0]}年${dateArray[1]}月${dateArray[2]}日`;
    },

    // 订单签证价格(特价商品使用特价)
    orderVisaPrice() {
      return (this.order.special_price ? this.order.special_price : this.order.applicant[0].sell_price) * this.order.applicant.length;
    },

    // 优惠券减免价格
    couponReducePrice() {
      if (this.orderSelectedCoupon.peer_coupon_type_id === 0 && this.orderSelectedCoupon && this.orderVisaPrice > this.orderSelectedCoupon.cash_reduce) {
        return this.orderSelectedCoupon.cash_reduce;
      } else if (this.orderSelectedCoupon.peer_coupon_type_id === 1 || this.orderSelectedCoupon.peer_coupon_type_id === 2) {
        return this.orderSelectedCoupon.discount_amount ? this.orderSelectedCoupon.discount_amount : 0;
      }
      return this.orderVisaPrice; 
    },
    

    // 订单总额
    totalAmount() {

      let amount = this.orderVisaPrice;

      // 优惠券(特价商品不能使用优惠券)
      if (!this.order.special_price && this.orderSelectedCoupon.id) {
        amount -= this.couponReducePrice;
      }

      // 选中顺丰就要加上顺丰取资料费用
      if (this.sfChecked) {
        amount += this.pickupAmount;
      }

      // 回寄运费
      if (this.sfReturnExpressPrice) {
        amount += this.sfReturnExpressPrice;
      }
      // 保险
      if (this.insurancePrice !== undefined) {
        // 这里也是平台保险
        amount += this.insurancePrice * 100 * this.order.applicant.length;
      } else if (this.platInsurance.insurance_type === 2) {
        // 平台保险
        amount += this.platInsurance.price * this.order.applicant.length;
      } else if (this.order.product_insurance && (this.order.product_insurance.insurance_type === 1 && this.userInsurance.checked)) {
        // 用户自选保险
        amount += this.userInsurance.insurance_fee * this.userInsurance.insurance_discount;
      }

      // 拒签无忧
      if (this.showRejectProductModule) {
        amount += this.rejectProductPrice;
      }
      
      return amount;
    },

    insurancePriceText() {
      let price = 0;
      if (this.insurancePrice === undefined) {
        // 这个需要重新计算哦
        price = this.platInsurance.price;
      } else {
        price = Number(this.insurancePrice);
      }
      return price;
    },
  },

  methods: {

    // 加载充值赠送优惠券数据
    getChargeCouponData() {
      return Http.post('/sys/recharge_activity', {})
        .then((data) => {
          if (data.rules) {
            this.showRechargeCoupon = true;
          }
        }).catch((e) => {
          if (e) console.log(e);
        });
    },

    // 获取应付金额(这个方法在这里用了，在父组件也调用了)
    getPayAmount() {
      if (typeof this.order.pay_amount === 'undefined') return 0;

      const totalPayAmount = this.totalAmount;

      // 首单立减删除
      /* if (this.order.first_order_reduce) {

        // 减去首单立减
        totalPayAmount -= this.order.first_order_reduce;

        // 至少支付要最少支付额度
        totalPayAmount = totalPayAmount > this.order.min_pay_amount ? totalPayAmount : this.order.min_pay_amount;
      } */

      this.$emit('totalPayAmount', totalPayAmount);
      return totalPayAmount;
    },

    commit() {
      this.$emit('commit');
    },
    showRechargeDialog() {
      sensorsdata.track('Recharge_voucher', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id || '',
        platform_type: 'PC',
        page_from: '支付页-底部充值',
      });
      this.$emit('handleShowRechargeDialog');
    },
    handlePricePayChange(e) {
      this.$emit('pricePayChange', e);
    },
  },
  mounted() {
    this.$on('pricePayChange', (e) => {
      this.insurancePrice = e;
    });
    this.getChargeCouponData();
  },
};
</script>

<style lang="less">
@import '../../../assets/less/variable.less';

#order-comfirm-pay-info {
  margin-top: 20px;
  padding: 20px 24px 16px 24px;
  background-color: white;
  line-height: 1;
  .pay-info-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-top: 12px;
  }
  .avaliable-balance {
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    .recharge-info{
      cursor: pointer;
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      background: #FAFBFC;
      height:42px;
      border-radius:16px 16px 0px 0px;
      padding-left: 64px;
      .recharge-info-label{
        font-size: 14px;
        color: #5F666E;
      }
      .recharge-icon{
        width: 120px;
        height: 114px;
        position: absolute;
        left: 226px;
        top: -26px;
        z-index: 1;
      }
    }
    .balance-box{
      position: relative;
      z-index: 3;
      background:#ECF4FF;
      border-radius:2px;
      height: 57px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      min-width: 376px;
      .balance-icon{
        width: 32px;
        height: 26px;
        background: url(../../../assets/imgs/insurance-new/icon-pay.png) no-repeat center / 100% 100%;
        margin-right: 12px;
      }
      .balance-label{
        color: #5F666E;
        font-size: 20px;
        margin-right: 12px;
      }
      .balance-value{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
        margin-right: 24px;
        flex-grow: 1;
      }
      .recharge-btn{
        height: 100%;
        padding: 0 24px;
        color: #599FFF;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        &::before{
          content: "";
          width: 1px;
          height: 16px;
          background:rgba(89,159,255,0.2);
          border-radius:1px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        &::after{
          content: "";
          width: 12px;
          height: 12px;
          background: url(../../../assets/imgs/insurance-new/icon-right-blue.png) no-repeat center / 100% 100%;
          margin-left: 4px;
        }
      }
    }
  }
  div.order-pay-infos {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    min-width: 270px;
    ul.order-pay-items {
      width: 100%;
      list-style-type: none;
      li {
        width: 100%;
        display: flex;
        font-size: 14px;
        color: #2F333D;
        margin-bottom: 20px;
        .item-label {
          display: flex;
          align-items: center;
          flex-grow: 1;
          span{
            color: #91999F;
          }
        }
        .item-value {
          flex-shrink: 0;
        }
        &.price{
          .item-value {
            display: flex;
            align-items: center;
            .original-price{
              margin-right: 6px;
              color: #C5C8CC;
              text-decoration: line-through;
            }
          }
        }
        &.coupon{
          .item-value {
            color: #FF8033;
          }
        }
        &.reject-product {
          padding: 14px 0;
          border-top: 1px solid #E9EEF2;
          margin-bottom: 0;
        }
      }
    }
  }
  div.total-pay {
    display: flex;
    align-items: center;
    border-top: 1px solid #E9EEF2;
    padding-top: 12px;
    margin-bottom: 42px;
    label {
      font-size: 20px;
      color: #2F333D;
      flex: 1;
    }
    span {
      font-size: 24px;
      color: #FF8033;
      font-weight: 600;
      i {
        font-size: 16px;
      }
    }
  }
  .pay-button{
    width: 100%;
    height: 50px;
    border-radius:2px;
    background: #FF8033;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    border: none;
    &.is-disabled{
      background:rgba(255,128,51,0.7);
    }
  }
  .special-price-date-explain {
    width: 100%;
    font-size: 12px;
    color: #6E5F5F;
    margin-bottom: 12px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    border-radius: 14px;
    background: rgba(255,128,51,0.08);
    &::after{
      content: "";
      border-width: 5px;
      border-style: solid;
      border-color: rgba(255,128,51,0.08) transparent transparent transparent;
      position: absolute;
      top: 100%;
      right: 16px;
    }
    span {
      color: #FF8033;
      margin: 0 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-comfirm-pay-info.vue